export * from './MenuDietaryPreferencesDescription';
